import React, { useState, useEffect } from "react";
import "./blacknavtop.css";
import { Link } from "react-router-dom";
import Grow from "@material-ui/core/Grow";
import Fade from "@material-ui/core/Fade";

class BlackNavtop extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      prevScrollpos: window.pageYOffset,
      visible: true,
      top: true,
    };
  }

  // Adds an event listener when the component is mount.
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  // Remove the event listener when the component is unmount.
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  // Hide or show the menu.
  handleScroll = () => {
    const { prevScrollpos } = this.state;

    // console.log(prevScrollpos);
    const currentScrollPos = window.pageYOffset;
    if (currentScrollPos == 0) {
      this.setState({ top: true });
    } else {
      this.setState({ top: false });
    }
    const visible = prevScrollpos > currentScrollPos;

    this.setState({
      prevScrollpos: currentScrollPos,
      visible,
    });
  };

  render() {
    return (
      <div id="BlackNavbar">
        <div
          className={
            this.state.visible
              ? this.state.top
                ? "active bnav blacksh"
                : "active bnav blacksh"
              : "hidden bnav"
          }
        >
          <div className="row">
            <div className="col-4"></div>
            <div className="col-4">
              <div className="container tcenter">
                <p style={{ marginBottom: "0px", fontSize: "12px" }}>calab.now.sh</p>
              </div>
            </div>
            <div className="col-4">
              <p style={{ marginBottom: "0px", fontSize: "12px" }}>
                <a href="tel:8851956910" style={{ color: "green" }}>
                  <i class="fas fa-phone-alt"></i> <b>8851956910</b>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BlackNavtop;
